import { render, staticRenderFns } from "./LoginThirdParty.vue?vue&type=template&id=5500200e&lang=pug"
import script from "./LoginThirdParty.vue?vue&type=script&lang=js"
export * from "./LoginThirdParty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports